import { useEffect } from 'react';

/**
 * 预加载首页资源的自定义Hook
 * 用于优化登出体验，减少跳转到首页时的加载时间
 */
export const usePreloadHome = () => {
  useEffect(() => {
    // 预加载首页路由模块
    const preloadHomeModule = async () => {
      try {
        await import('../pages/Index');
      } catch (error) {
        console.warn('Failed to preload home page module:', error);
      }
    };

    preloadHomeModule();

    // 创建预加载链接，告诉浏览器预加载首页资源
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = '/';
    link.as = 'document';
    
    // 避免重复添加
    const existingLink = document.querySelector('link[href="/"][rel="prefetch"]');
    if (!existingLink) {
      document.head.appendChild(link);
    }

    // 预加载首页可能需要的关键资源
    const preloadCriticalResources = () => {
      // 预加载首页可能用到的图片
      const criticalImages = [
        '/favicon.ico',
        '/placeholder.svg'
      ];

      criticalImages.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    };

    preloadCriticalResources();

    // 清理函数
    return () => {
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, []);
};